import React, { useState } from 'react';
import { products } from '../mockData';
import { Sparkles } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./ui/carousel";

const ProductsSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', 'Cakes', 'Cupcakes', 'Small Cakes', 'Specialty', 'Cake Pops', 'Mini Donuts'];

  const filteredProducts = selectedCategory === 'All' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  return (
    <section id="products" className="products-section py-20 lg:py-32">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="section-label">Our Menu</span>
          <h2 className="section-title mt-3 mb-4">Pistachio Perfection
            <span className="block text-gold">In Every Bite</span>
          </h2>
          <p className="text-lg text-olive-dark">
            From classic cakes to creative treats, explore our full range of handcrafted pistachio delights. 
            All items available for custom orders!
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map(category => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`category-button ${
                selectedCategory === category ? 'category-button-active' : ''
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8">
          {filteredProducts.map(product => (
            <div key={product.id} className="product-card group">
              <div className="product-image-wrapper">
                {product.images && product.images.length > 1 ? (
                  <Carousel className="w-full">
                    <CarouselContent>
                      {product.images.map((img, index) => (
                        <CarouselItem key={index}>
                          <img 
                            src={img} 
                            alt={`${product.name} - Image ${index + 1}`}
                            className="product-image"
                          />
                        </CarouselItem>
                      ))}
                    </CarouselContent>
                    <CarouselPrevious className="left-2 h-8 w-8" />
                    <CarouselNext className="right-2 h-8 w-8" />
                  </Carousel>
                ) : (
                  <img 
                    src={product.image || product.images?.[0]} 
                    alt={product.name}
                    className="product-image"
                  />
                )}
                {product.customizable && (
                  <div className="product-badge">
                    <Sparkles size={14} />
                    <span>Customizable</span>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="product-title">{product.name}</h3>
                <p className="product-description">{product.description}</p>
                <button 
                  className="product-cta-button"
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  {product.buttonText || 'Order Now'}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Custom Orders CTA */}
        <div className="custom-orders-banner mt-16">
          <div className="text-center space-y-4">
            <h3 className="text-3xl lg:text-4xl font-bold text-olive">
              Looking for Something Special?
            </h3>
            <p className="text-lg text-olive-dark max-w-2xl mx-auto">
              We love bringing your pistachio dreams to life! Whether it's a birthday cake, wedding desserts, 
              or a unique creation, we're here to make it happen.
            </p>
            <button onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }} className="cta-button-primary">
              Request Custom Order
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
